import { render, staticRenderFns } from "./duoSalesMobile.vue?vue&type=template&id=bf4e2fc4&scoped=true&"
import script from "./duoSalesMobile.vue?vue&type=script&lang=js&"
export * from "./duoSalesMobile.vue?vue&type=script&lang=js&"
import style0 from "./duoSalesMobile.vue?vue&type=style&index=0&id=bf4e2fc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4e2fc4",
  null
  
)

export default component.exports